import { IObservable, Subject } from '~/rage/utils';
import { CharacterLicense } from '~/shared';
import { ILicense, ILicensesService } from './types';

export class LicensesServiceStub implements ILicensesService {
	private licenses = new Subject<ILicense[]>([
		{
			id: CharacterLicense.DrivingBike,
			name: 'Управление мотоциклами',
			letter: 'A',
			isOwned: true,
			issueDate: Date.now() - 1000 * 60 * 60 * 24 * 7,
		},
		{
			id: CharacterLicense.DrivingCar,
			name: 'Управление автомобилями',
			letter: 'B',
			isOwned: false,
		},
	]);

	public getLicenses(): IObservable<ILicense[]> {
		return this.licenses;
	}

	public getLicenseName(licenseId: CharacterLicense): string {
		return this.licenses.getValue().find((license) => license.id === licenseId)!
			.name;
	}

	public getLicenseLetter(licenseId: CharacterLicense): string {
		return this.licenses.getValue().find((license) => license.id === licenseId)!
			.letter;
	}

	public hasLicense(licenseId: CharacterLicense): boolean {
		return this.licenses.getValue().find((license) => license.id === licenseId)!
			.isOwned;
	}
}
